import { baseApiClient as api } from "../baseService";

export const addTagTypes = [
  "docx_templates",
  "docx_template_fields",
  "document-generation",
  "pdf_templates",
  "pdf_template_fields",
  "pdf_template_images",
  "document_generation_templates",
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      docxTemplatesCreate: build.mutation<
        DocxTemplatesCreateApiResponse,
        DocxTemplatesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document-generation/docx/templates/`,
          method: "POST",
          body: queryArg.createDocxTemplateSchema,
        }),
        invalidatesTags: ["docx_templates"],
      }),
      docxTemplatesRetrieve: build.query<
        DocxTemplatesRetrieveApiResponse,
        DocxTemplatesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document-generation/docx/templates/${queryArg.templateId}/`,
        }),
        providesTags: ["docx_templates"],
      }),
      docxTemplatesUpdate: build.mutation<
        DocxTemplatesUpdateApiResponse,
        DocxTemplatesUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document-generation/docx/templates/${queryArg.templateId}/`,
          method: "PUT",
          body: queryArg.updateDocxTemplateSchema,
        }),
        invalidatesTags: ["docx_templates"],
      }),
      docxTemplatesDestroy: build.mutation<
        DocxTemplatesDestroyApiResponse,
        DocxTemplatesDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document-generation/docx/templates/${queryArg.templateId}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["docx_templates"],
      }),
      docxTemplateFieldsList: build.query<
        DocxTemplateFieldsListApiResponse,
        DocxTemplateFieldsListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document-generation/docx/templates/${queryArg.templateId}/fields/`,
        }),
        providesTags: ["docx_template_fields"],
      }),
      docxTemplateFieldsCreate: build.mutation<
        DocxTemplateFieldsCreateApiResponse,
        DocxTemplateFieldsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document-generation/docx/templates/${queryArg.templateId}/fields/`,
          method: "POST",
          body: queryArg.createDocxTemplateFieldSchema,
        }),
        invalidatesTags: ["docx_template_fields"],
      }),
      docxTemplateFieldsUpdate: build.mutation<
        DocxTemplateFieldsUpdateApiResponse,
        DocxTemplateFieldsUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document-generation/docx/templates/${queryArg.templateId}/fields/${queryArg.fieldId}/`,
          method: "PUT",
          body: queryArg.updateDocxTemplateFieldSchema,
        }),
        invalidatesTags: ["docx_template_fields"],
      }),
      docxTemplateFieldsDestroy: build.mutation<
        DocxTemplateFieldsDestroyApiResponse,
        DocxTemplateFieldsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document-generation/docx/templates/${queryArg.templateId}/fields/${queryArg.fieldId}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["docx_template_fields"],
      }),
      docxTemplatesReplaceFields: build.mutation<
        DocxTemplatesReplaceFieldsApiResponse,
        DocxTemplatesReplaceFieldsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document-generation/docx/templates/${queryArg.templateId}/replace_fields/`,
          method: "POST",
          body: queryArg.bulkCreateDocxTemplateFieldSchema,
        }),
        invalidatesTags: ["docx_templates"],
      }),
      docxTemplatesExtractFields: build.mutation<
        DocxTemplatesExtractFieldsApiResponse,
        DocxTemplatesExtractFieldsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document-generation/docx/templates/extract_fields/`,
          method: "POST",
          body: queryArg.extractDocxFieldsSchema,
        }),
        invalidatesTags: ["document-generation"],
      }),
      docxTemplatesRender: build.mutation<
        DocxTemplatesRenderApiResponse,
        DocxTemplatesRenderApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document-generation/docx/templates/render/`,
          method: "POST",
          body: queryArg.renderDocxTemplateSchema,
        }),
        invalidatesTags: ["document-generation"],
      }),
      docxTemplatesRenderToPdf: build.mutation<
        DocxTemplatesRenderToPdfApiResponse,
        DocxTemplatesRenderToPdfApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document-generation/docx/templates/render_to_pdf/`,
          method: "POST",
          body: queryArg.renderDocxToPdfSchema,
        }),
        invalidatesTags: ["document-generation"],
      }),
      pdfTemplatesCreate: build.mutation<
        PdfTemplatesCreateApiResponse,
        PdfTemplatesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document-generation/pdf/templates/`,
          method: "POST",
          body: queryArg.createPdfTemplateSchema,
        }),
        invalidatesTags: ["pdf_templates"],
      }),
      pdfTemplatesRetrieve: build.query<
        PdfTemplatesRetrieveApiResponse,
        PdfTemplatesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document-generation/pdf/templates/${queryArg.templateId}/`,
        }),
        providesTags: ["pdf_templates"],
      }),
      pdfTemplatesUpdate: build.mutation<
        PdfTemplatesUpdateApiResponse,
        PdfTemplatesUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document-generation/pdf/templates/${queryArg.templateId}/`,
          method: "PUT",
          body: queryArg.updatePdfTemplateSchema,
        }),
        invalidatesTags: ["pdf_templates"],
      }),
      pdfTemplatesDestroy: build.mutation<
        PdfTemplatesDestroyApiResponse,
        PdfTemplatesDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document-generation/pdf/templates/${queryArg.templateId}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["pdf_templates"],
      }),
      pdfTemplateFieldsList: build.query<
        PdfTemplateFieldsListApiResponse,
        PdfTemplateFieldsListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document-generation/pdf/templates/${queryArg.templateId}/fields/`,
        }),
        providesTags: ["pdf_template_fields"],
      }),
      pdfTemplateFieldsCreate: build.mutation<
        PdfTemplateFieldsCreateApiResponse,
        PdfTemplateFieldsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document-generation/pdf/templates/${queryArg.templateId}/fields/`,
          method: "POST",
          body: queryArg.createPdfTemplateFieldSchema,
        }),
        invalidatesTags: ["pdf_template_fields"],
      }),
      pdfTemplateFieldsRetrieve: build.query<
        PdfTemplateFieldsRetrieveApiResponse,
        PdfTemplateFieldsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document-generation/pdf/templates/${queryArg.templateId}/fields/${queryArg.fieldId}/`,
        }),
        providesTags: ["pdf_template_fields"],
      }),
      pdfTemplateFieldsUpdate: build.mutation<
        PdfTemplateFieldsUpdateApiResponse,
        PdfTemplateFieldsUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document-generation/pdf/templates/${queryArg.templateId}/fields/${queryArg.fieldId}/`,
          method: "PUT",
          body: queryArg.updatePdfTemplateFieldSchema,
        }),
        invalidatesTags: ["pdf_template_fields"],
      }),
      pdfTemplateFieldsDestroy: build.mutation<
        PdfTemplateFieldsDestroyApiResponse,
        PdfTemplateFieldsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document-generation/pdf/templates/${queryArg.templateId}/fields/${queryArg.fieldId}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["pdf_template_fields"],
      }),
      pdfTemplateReplaceFields: build.mutation<
        PdfTemplateReplaceFieldsApiResponse,
        PdfTemplateReplaceFieldsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document-generation/pdf/templates/${queryArg.templateId}/replace_fields/`,
          method: "POST",
          body: queryArg.bulkCreatePdfTemplateFieldSchema,
        }),
        invalidatesTags: ["pdf_template_fields"],
      }),
      pdfTemplatesNormalizePdf: build.mutation<
        PdfTemplatesNormalizePdfApiResponse,
        PdfTemplatesNormalizePdfApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document-generation/pdf/templates/normalize_pdf/`,
          method: "POST",
          body: queryArg.normalizePdfSchema,
        }),
        invalidatesTags: ["document-generation"],
      }),
      pdfTemplateImagesCreate: build.mutation<
        PdfTemplateImagesCreateApiResponse,
        PdfTemplateImagesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document-generation/pdf/templates_images/`,
          method: "POST",
          body: queryArg.createPdfTemplateImageSchema,
        }),
        invalidatesTags: ["pdf_template_images"],
      }),
      pdfTemplateImagesRetrieve: build.query<
        PdfTemplateImagesRetrieveApiResponse,
        PdfTemplateImagesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document-generation/pdf/templates_images/${queryArg.imageId}/`,
        }),
        providesTags: ["pdf_template_images"],
      }),
      documentGenerationTemplatesRetrieve: build.query<
        DocumentGenerationTemplatesRetrieveApiResponse,
        DocumentGenerationTemplatesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/document-generation/templates/${queryArg.templateId}/`,
        }),
        providesTags: ["document_generation_templates"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as enhancedApi };
export type DocxTemplatesCreateApiResponse =
  /** status 201  */ DocxTemplateSchema;
export type DocxTemplatesCreateApiArg = {
  createDocxTemplateSchema: CreateDocxTemplateSchema;
};
export type DocxTemplatesRetrieveApiResponse =
  /** status 200  */ DocxTemplateSchema;
export type DocxTemplatesRetrieveApiArg = {
  templateId: string;
};
export type DocxTemplatesUpdateApiResponse =
  /** status 200  */ DocxTemplateSchema;
export type DocxTemplatesUpdateApiArg = {
  templateId: string;
  updateDocxTemplateSchema: UpdateDocxTemplateSchema;
};
export type DocxTemplatesDestroyApiResponse = unknown;
export type DocxTemplatesDestroyApiArg = {
  templateId: string;
};
export type DocxTemplateFieldsListApiResponse =
  /** status 200  */ DocxTemplateFieldListSchema[];
export type DocxTemplateFieldsListApiArg = {
  templateId: string;
};
export type DocxTemplateFieldsCreateApiResponse =
  /** status 201  */ DocxTemplateFieldSchema;
export type DocxTemplateFieldsCreateApiArg = {
  templateId: string;
  createDocxTemplateFieldSchema: CreateDocxTemplateFieldSchema;
};
export type DocxTemplateFieldsUpdateApiResponse =
  /** status 200  */ DocxTemplateFieldSchema;
export type DocxTemplateFieldsUpdateApiArg = {
  fieldId: string;
  templateId: string;
  updateDocxTemplateFieldSchema: UpdateDocxTemplateFieldSchema;
};
export type DocxTemplateFieldsDestroyApiResponse = unknown;
export type DocxTemplateFieldsDestroyApiArg = {
  fieldId: string;
  templateId: string;
};
export type DocxTemplatesReplaceFieldsApiResponse =
  /** status 200  */ DocxTemplateSchema;
export type DocxTemplatesReplaceFieldsApiArg = {
  templateId: string;
  bulkCreateDocxTemplateFieldSchema: BulkCreateDocxTemplateFieldSchema;
};
export type DocxTemplatesExtractFieldsApiResponse =
  /** status 200  */ ExtractDocxFieldsResponseSchema;
export type DocxTemplatesExtractFieldsApiArg = {
  extractDocxFieldsSchema: ExtractDocxFieldsSchema;
};
export type DocxTemplatesRenderApiResponse = unknown;
export type DocxTemplatesRenderApiArg = {
  renderDocxTemplateSchema: RenderDocxTemplateSchema;
};
export type DocxTemplatesRenderToPdfApiResponse = unknown;
export type DocxTemplatesRenderToPdfApiArg = {
  renderDocxToPdfSchema: RenderDocxToPdfSchema;
};
export type PdfTemplatesCreateApiResponse =
  /** status 201  */ PdfTemplateSchema;
export type PdfTemplatesCreateApiArg = {
  createPdfTemplateSchema: CreatePdfTemplateSchema;
};
export type PdfTemplatesRetrieveApiResponse =
  /** status 200  */ PdfTemplateSchema;
export type PdfTemplatesRetrieveApiArg = {
  templateId: string;
};
export type PdfTemplatesUpdateApiResponse =
  /** status 200  */ PdfTemplateSchema;
export type PdfTemplatesUpdateApiArg = {
  templateId: string;
  updatePdfTemplateSchema: UpdatePdfTemplateSchema;
};
export type PdfTemplatesDestroyApiResponse = unknown;
export type PdfTemplatesDestroyApiArg = {
  templateId: string;
};
export type PdfTemplateFieldsListApiResponse =
  /** status 200  */ PdfTemplateFieldListSchema[];
export type PdfTemplateFieldsListApiArg = {
  templateId: string;
};
export type PdfTemplateFieldsCreateApiResponse =
  /** status 201  */ PdfTemplateFieldSchema;
export type PdfTemplateFieldsCreateApiArg = {
  templateId: string;
  createPdfTemplateFieldSchema: CreatePdfTemplateFieldSchema;
};
export type PdfTemplateFieldsRetrieveApiResponse =
  /** status 200  */ PdfTemplateFieldSchema;
export type PdfTemplateFieldsRetrieveApiArg = {
  fieldId: string;
  templateId: string;
};
export type PdfTemplateFieldsUpdateApiResponse =
  /** status 200  */ PdfTemplateFieldSchema;
export type PdfTemplateFieldsUpdateApiArg = {
  fieldId: string;
  templateId: string;
  updatePdfTemplateFieldSchema: UpdatePdfTemplateFieldSchema;
};
export type PdfTemplateFieldsDestroyApiResponse = unknown;
export type PdfTemplateFieldsDestroyApiArg = {
  fieldId: string;
  templateId: string;
};
export type PdfTemplateReplaceFieldsApiResponse =
  /** status 201  */ PdfTemplateSchema;
export type PdfTemplateReplaceFieldsApiArg = {
  templateId: string;
  bulkCreatePdfTemplateFieldSchema: BulkCreatePdfTemplateFieldSchema;
};
export type PdfTemplatesNormalizePdfApiResponse = unknown;
export type PdfTemplatesNormalizePdfApiArg = {
  normalizePdfSchema: NormalizePdfSchema;
};
export type PdfTemplateImagesCreateApiResponse =
  /** status 201  */ PdfTemplateImageSchema;
export type PdfTemplateImagesCreateApiArg = {
  createPdfTemplateImageSchema: CreatePdfTemplateImageSchema;
};
export type PdfTemplateImagesRetrieveApiResponse =
  /** status 200  */ PdfTemplateImageSchema;
export type PdfTemplateImagesRetrieveApiArg = {
  imageId: string;
};
export type DocumentGenerationTemplatesRetrieveApiResponse =
  /** status 200  */ DocumentGenerationTemplateSchema;
export type DocumentGenerationTemplatesRetrieveApiArg = {
  templateId: string;
};
export type TemplateStatus = "ACTIVE" | "SUPERSEDED" | "ARCHIVED";
export type TemplateFieldTypes =
  | "TEXT"
  | "DATE"
  | "CHECKBOX"
  | "IMAGE"
  | "ARRAY";
export type TemplateFieldSource = "MANUAL" | "MATTER_CONTEXT";
export type MatterContextField =
  | "firmName"
  | "firmFullName"
  | "firmParalegalSig"
  | "firmManagingParalegalName"
  | "firmManagingParalegalEmail"
  | "firmManagingParalegalInitials"
  | "firmManagingParalegalPhone"
  | "firmEmail"
  | "firmPhone"
  | "firmAddress"
  | "firmState"
  | "firmPreFilingContingencyFee"
  | "firmPostFilingContingencyFee"
  | "firmLetterheadImageUrl"
  | "matterName"
  | "matterStatus"
  | "matterMatterType"
  | "matterDateOfLoss"
  | "matterCity"
  | "matterState"
  | "matterStatuteOfLimitationsDate"
  | "attorneyName"
  | "attorneyFirstName"
  | "attorneyLastName"
  | "attorneyEmail"
  | "attorneyPhone"
  | "attorneyBarNumber"
  | "attorneyTitle"
  | "attorneyInitials"
  | "attorneySig"
  | "clientName"
  | "clientFirstName"
  | "clientLastName"
  | "clientEmail"
  | "clientDateOfBirth"
  | "clientAddress"
  | "clientAddress1"
  | "clientAddress2"
  | "clientAddress3"
  | "clientCity"
  | "clientState"
  | "clientZip"
  | "clientPhone"
  | "clientLastFourOfSsn"
  | "clientSsn"
  | "clientHipaaSignedDate"
  | "clientHipaaSigUrl"
  | "clientHipaaCleanedSigUrl"
  | "policeName"
  | "policeAddress"
  | "policePhone"
  | "policeEmail"
  | "policePoliceReportNumber"
  | "policeReportedIncidentDate"
  | "incidentIncidentType"
  | "policeDescription"
  | "policeReportedLocation"
  | "policeAttestationStatus"
  | "policeAddress1"
  | "policeAddress2"
  | "medicalName"
  | "medicalDatesOfService"
  | "medicalTreatment"
  | "medicalAddress"
  | "medicalAddress1"
  | "medicalAddress2"
  | "medicalPhone"
  | "medicalEmail"
  | "medicalStillTreating"
  | "medicalDateOfRecordsRequest"
  | "insuranceDateFiled"
  | "insurancePolicyType"
  | "insuranceHolder"
  | "insuranceCarrier"
  | "insurancePolicyNumber"
  | "insurancePolicyLimitations"
  | "insuranceVehicleDescription"
  | "insuranceClaimNumber"
  | "insuranceAdjusterName"
  | "insuranceAdjusterPhone"
  | "insuranceAdjusterEmail"
  | "insuranceMemberId"
  | "insuranceGroupId"
  | "insuranceAddress"
  | "insuranceAddress1"
  | "insuranceAddress2"
  | "insuranceCarrierFax"
  | "insuranceContactMethod"
  | "insuranceHealthCarrierProgramName"
  | "incidentDescription"
  | "incidentDateOfLoss"
  | "incidentTimeOfLoss"
  | "incidentLocation"
  | "incidentInjuriesDescribed"
  | "incidentHospital"
  | "incidentAmbulance"
  | "incidentAtFaultName"
  | "incidentAtFaultAddress1"
  | "incidentAtFaultAddress2"
  | "incidentPremisesName"
  | "incidentPremisesAddress1"
  | "incidentPremisesAddress2"
  | "incidentMinus2HoursLossTime"
  | "incidentPlus2HoursLossTime"
  | "treatmentRequestDate"
  | "treatmentChannelType"
  | "treatmentChannelAddress"
  | "treatmentChannelValue"
  | "treatmentChannelPortalRequestId"
  | "transmissionDate"
  | "transmissionMethod"
  | "transmissionOneWeekFromToday"
  | "recipientName"
  | "recipientAddress1"
  | "recipientAddress2"
  | "recipientCity"
  | "recipientState"
  | "recipientZip"
  | "recipientFullAddress"
  | "matterMedicalList"
  | "clientInjuries"
  | "insurance1pCarrier"
  | "insurance1pPolicyNumber"
  | "insurance1pClaimNumber"
  | "insurance1pAdjusterName"
  | "insurance1pAdjusterPhone"
  | "insurance1pAdjusterEmail"
  | "insurance1pPolicyLimitations"
  | "insurance3pCarrier"
  | "insurance3pPolicyNumber"
  | "insurance3pClaimNumber"
  | "insurance3pAdjusterName"
  | "insurance3pAdjusterPhone"
  | "insurance3pAdjusterEmail"
  | "insurance3pPolicyLimitations"
  | "insuranceHealthCarrier"
  | "insuranceHealthPolicyNumber"
  | "insuranceHealthMemberId"
  | "insuranceHealthGroupId"
  | "insuranceHealthAdjusterName"
  | "insuranceHealthAdjusterPhone"
  | "insuranceHealthAdjusterEmail";
export type DocxTemplateFieldSchema = {
  id: string | string;
  created_at: string;
  modified_at: string;
  display_name?: string | null;
  field_type: TemplateFieldTypes;
  field_source: TemplateFieldSource;
  field_source_context_key?: MatterContextField;
  field_reference: string;
  is_optional?: boolean;
  type?: "DOCX";
  template_id: string | string;
};
export type SlotRequirementLevel = "required" | "optional" | "not_used";
export type RequiredEntitySlotsSchema = {
  coverage_1p?: SlotRequirementLevel;
  coverage_3p?: SlotRequirementLevel;
  coverage_health?: SlotRequirementLevel;
  medical_providers?: SlotRequirementLevel;
};
export type DocxTemplateSchema = {
  id: string | string;
  created_at: string;
  modified_at: string;
  name?: string | null;
  description?: string | null;
  status: TemplateStatus;
  type?: "DOCX";
  docx_url: string;
  fields: DocxTemplateFieldSchema[];
  required_entity_slots?: RequiredEntitySlotsSchema;
};
export type TemplateCategory =
  | "HIPAA_COVERSHEET"
  | "HIPAA_AUTHORIZATION"
  | "FOIA_LETTER"
  | "LIEN_NOTICE"
  | "RETAINER"
  | "LOR_GENERIC"
  | "LOR_FIRST_PARTY"
  | "LOR_THIRD_PARTY"
  | "LOR_HEALTH"
  | "WELCOME_LETTER"
  | "DROP_LETTER"
  | "JOINT_VENTURE_NOTICE"
  | "CLIENT_COMMUNICATION"
  | "MEDICAL_RECORDS_REQUEST"
  | "AFFIDAVIT"
  | "LETTER_OF_PROTECTION"
  | "PRESERVATION_LETTER"
  | "PIP_DEMAND"
  | "OTHER";
export type CreateDocxTemplateSchema = {
  name?: string | null;
  description?: string | null;
  status?: TemplateStatus;
  file: Blob;
  firm_id?: (string | string) | null;
  template_category?: TemplateCategory;
};
export type UpdateDocxTemplateSchema = {
  id: string | string;
  name?: string | null;
  description?: string | null;
  status?: TemplateStatus;
};
export type DocxTemplateFieldListSchema = {
  fields: DocxTemplateFieldSchema[];
};
export type CreateDocxTemplateFieldSchema = {
  display_name?: string | null;
  field_type: TemplateFieldTypes;
  field_source: TemplateFieldSource;
  field_source_context_key?: MatterContextField;
  field_reference: string;
  is_optional?: boolean;
  template_id: string | string;
};
export type UpdateDocxTemplateFieldSchema = {
  display_name?: string | null;
  field_type: TemplateFieldTypes;
  field_source: TemplateFieldSource;
  field_source_context_key?: MatterContextField;
  field_reference?: string | null;
  is_optional?: boolean;
  id: string | string;
};
export type BulkCreateDocxTemplateFieldSchema = {
  fields: CreateDocxTemplateFieldSchema[];
};
export type BaseDocxTemplateFieldSchema = {
  display_name?: string | null;
  field_type: TemplateFieldTypes;
  field_source: TemplateFieldSource;
  field_source_context_key?: MatterContextField;
  field_reference: string;
  is_optional?: boolean;
};
export type ExtractDocxFieldsResponseSchema = {
  fields: BaseDocxTemplateFieldSchema[];
};
export type ExtractDocxFieldsSchema = {
  docx: Blob;
};
export type RenderDocxTemplateSchema = {
  docx: Blob;
  fields: {
    [key: string]:
      | (
          | string
          | any[]
          | {
              [key: string]: any;
            }
        )
      | null;
  };
  matter_id?: (string | string) | null;
};
export type RenderDocxToPdfSchema = {
  docx: Blob;
};
export type PdfTemplateFieldBoundingBox = {
  x: number;
  y: number;
  width: number;
  height: number;
};
export type PdfTemplateFieldSchema = {
  id: string | string;
  created_at: string;
  modified_at: string;
  type?: "PDF";
  field_type: TemplateFieldTypes;
  field_source: TemplateFieldSource;
  field_source_context_key?: MatterContextField;
  field_source_image_id?: (string | string) | null;
  field_source_default_value?: string | null;
  page_number: number;
  position: PdfTemplateFieldBoundingBox;
  template_id: string | string;
  field_source_image_url?: string | null;
};
export type PdfTemplateSchema = {
  id: string | string;
  created_at: string;
  modified_at: string;
  name?: string | null;
  description?: string | null;
  status: TemplateStatus;
  type?: "PDF";
  pdf_url: string;
  fields: PdfTemplateFieldSchema[];
};
export type CreatePdfTemplateSchema = {
  name?: string | null;
  description?: string | null;
  status?: TemplateStatus;
  file: Blob;
  firm_id?: (string | string) | null;
  template_category?: TemplateCategory;
};
export type UpdatePdfTemplateSchema = {
  id: string | string;
  name?: string | null;
  description?: string | null;
  status?: TemplateStatus;
};
export type PdfTemplateFieldListSchema = {
  fields: PdfTemplateFieldSchema[];
};
export type CreatePdfTemplateFieldSchema = {
  type?: "PDF";
  field_type: TemplateFieldTypes;
  field_source: TemplateFieldSource;
  field_source_context_key?: MatterContextField;
  field_source_image_id?: (string | string) | null;
  field_source_default_value?: string | null;
  page_number: number;
  position: PdfTemplateFieldBoundingBox;
  template_id: string | string;
};
export type UpdatePdfTemplateFieldSchema = {
  id: string | string;
  field_type?: TemplateFieldTypes;
  field_source?: TemplateFieldSource;
  field_source_context_key?: MatterContextField;
  field_source_default_value?: string | null;
  page_number?: number | null;
  field_source_image_id?: (string | string) | null;
  position?: PdfTemplateFieldBoundingBox;
};
export type BulkCreatePdfTemplateFieldSchema = {
  fields: CreatePdfTemplateFieldSchema[];
};
export type NormalizePdfSchema = {
  pdf: Blob;
};
export type PdfTemplateImageSchema = {
  id: string | string;
  created_at: string;
  modified_at: string;
  image_url: string;
};
export type CreatePdfTemplateImageSchema = {
  image: Blob;
};
export type TemplateType = "PDF" | "DOCX";
export type DocumentGenerationTemplateSchema = {
  id: string | string;
  name?: string | null;
  display_name?: string | null;
  description?: string | null;
  status: TemplateStatus;
  type: TemplateType;
  category?: TemplateCategory;
  is_global?: boolean;
  is_global_default?: boolean;
  is_firm_default?: boolean;
  required_entity_slots?: RequiredEntitySlotsSchema;
};
export const {
  useDocxTemplatesCreateMutation,
  useDocxTemplatesRetrieveQuery,
  useDocxTemplatesUpdateMutation,
  useDocxTemplatesDestroyMutation,
  useDocxTemplateFieldsListQuery,
  useDocxTemplateFieldsCreateMutation,
  useDocxTemplateFieldsUpdateMutation,
  useDocxTemplateFieldsDestroyMutation,
  useDocxTemplatesReplaceFieldsMutation,
  useDocxTemplatesExtractFieldsMutation,
  useDocxTemplatesRenderMutation,
  useDocxTemplatesRenderToPdfMutation,
  usePdfTemplatesCreateMutation,
  usePdfTemplatesRetrieveQuery,
  usePdfTemplatesUpdateMutation,
  usePdfTemplatesDestroyMutation,
  usePdfTemplateFieldsListQuery,
  usePdfTemplateFieldsCreateMutation,
  usePdfTemplateFieldsRetrieveQuery,
  usePdfTemplateFieldsUpdateMutation,
  usePdfTemplateFieldsDestroyMutation,
  usePdfTemplateReplaceFieldsMutation,
  usePdfTemplatesNormalizePdfMutation,
  usePdfTemplateImagesCreateMutation,
  usePdfTemplateImagesRetrieveQuery,
  useDocumentGenerationTemplatesRetrieveQuery,
} = injectedRtkApi;
